import { Capacitor } from "@capacitor/core";
import { IS_CONNECTION_SESSION } from "@/utils/connection-session";
import { signupAcquisition } from "./signupAcquisition";

export function captureBrowserSignupEntry(referrer?: string, href?: string) {
  if (typeof window === "undefined" || IS_CONNECTION_SESSION || Capacitor.isNativePlatform()) return;
  let storage: Storage | undefined;
  try { storage = window.localStorage; } catch { /* Keep the observation in memory. */ }
  signupAcquisition.capture(href ?? window.location.href, referrer ?? document.referrer, storage);
}

// Imported before App: marketing modules may construct store links during evaluation.
captureBrowserSignupEntry();
